{
  "expo": {
    "name": "Trovie",
    "slug": "trovie",
    "owner": "trovie",
    "scheme": "trovie",
    "version": "1.6.0",
    "icon": "./assets/icon.png",
    "orientation": "default",
    "userInterfaceStyle": "automatic",
    "runtimeVersion": {
      "policy": "appVersion"
    },
    "updates": {
      "url": "https://u.expo.dev/8c31d84c-eef5-4ed3-bb39-7c41c13d92de"
    },
    "ios": {
      "supportsTablet": true,
      "bundleIdentifier": "app.trovie.mobile",
      "infoPlist": {
        "ITSAppUsesNonExemptEncryption": false,
        "NSBluetoothAlwaysUsageDescription": "Trovie connects to your NIIMBOT label printer over Bluetooth to print inventory labels. It connects only while a print job is running."
      }
    },
    "android": {
      "package": "app.trovie.mobile",
      "adaptiveIcon": {
        "foregroundImage": "./assets/adaptive-icon.png",
        "backgroundColor": "#17243f"
      },
      "permissions": [
        "android.permission.CAMERA",
        "android.permission.RECORD_AUDIO",
        "android.permission.ACCESS_COARSE_LOCATION",
        "android.permission.ACCESS_FINE_LOCATION"
      ]
    },
    "web": {
      "bundler": "metro",
      "output": "single",
      "favicon": "./assets/favicon.png"
    },
    "plugins": [
      "expo-router",
      [
        "expo-camera",
        {
          "cameraPermission": "Trovie uses the camera to scan and identify cards."
        }
      ],
      [
        "expo-location",
        {
          "locationWhenInUsePermission": "Trovie uses your location to show card shows near you."
        }
      ],
      "expo-notifications",
      "expo-secure-store",
      "expo-web-browser",
      [
        "@clerk/expo",
        {
          "appleSignIn": true
        }
      ],
      "expo-font",
      "expo-asset",
      [
        "react-native-share",
        {
          "ios": [
            "instagram-stories"
          ],
          "android": [
            "com.instagram.android"
          ]
        }
      ],
      [
        "expo-splash-screen",
        {
          "image": "./assets/splash-icon.png",
          "backgroundColor": "#eef1fb",
          "resizeMode": "contain",
          "imageWidth": 200,
          "dark": {
            "image": "./assets/splash-icon-dark.png",
            "backgroundColor": "#202940"
          }
        }
      ],
      "./plugins/with-device-orientation",
      "./plugins/with-niimbot-device-libs",
      "./plugins/with-safe-pods-uuids",
      "./plugins/with-gradle-memory",
      "./plugins/with-litert-namespace",
      [
        "expo-build-properties",
        {
          "android": {
            "enableMinifyInReleaseBuilds": true,
            "extraProguardRules": "-dontwarn kotlin.MustUseReturnValues"
          }
        }
      ],
      "expo-image",
      "expo-sharing",
      "expo-status-bar",
      "@react-native-community/datetimepicker",
      [
        "react-native-nano-icons",
        {
          "iconSets": [
            {
              "inputDir": "./assets/icons/glyphs",
              "fontFamily": "icons",
              "linking": "dynamic",
              "web": true
            }
          ]
        }
      ]
    ],
    "extra": {
      "apiBaseUrl": "http://localhost:8000",
      "eas": {
        "projectId": "8c31d84c-eef5-4ed3-bb39-7c41c13d92de"
      },
      "router": {}
    }
  }
}
